import { render, staticRenderFns } from "./dispute-dialog-client-info-card.vue?vue&type=template&id=4db8995d&scoped=true"
import script from "./dispute-dialog-client-info-card.vue?vue&type=script&lang=js"
export * from "./dispute-dialog-client-info-card.vue?vue&type=script&lang=js"
import style0 from "./dispute-dialog-client-info-card.vue?vue&type=style&index=0&id=4db8995d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4db8995d",
  null
  
)

export default component.exports